import React, { Component } from 'react'
import { connect } from 'react-redux'
import classnames from 'classnames'

import Button from './UI/Button'

import tooltips from '../constants/tooltips.json'

import {
  setLearnModeRecord,
  selectLearnBar,
  setLearnModeStrikeType,
  createBlankRecord,
  resetBarRecord,
  checkBarRecords,
  setLearnStrikeCount,
  calculateAndSendBarAverages,
  storeAndSendBarMults,
  learnModeComplete,
} from "../actions";

class LearnModeSteps extends Component {
  state = {
    startIndex: null
  }

  componentDidUpdate() {
    if (!this.props.isRecording) return;

    const records = this.props.learnRecords;
    const currentLearnBar = this.props.currentLearnBar;
    const currentLearnRecord = records[currentLearnBar];

    if (currentLearnRecord === undefined) return;
    
    const strikeType = this.props.learnModeStrikeType;
    const currentRecord = records[currentLearnBar][strikeType];

    if (currentRecord.length !== this.props.learnModeStrikeCount) {
      return;
    }

    // check records on every update
    this.props.onCheckBarRecords(records[currentLearnBar][strikeType]);

    let completeTally = 0
    records.forEach((record, index) => {
      if(record === undefined) return
      
      const {soft, hard} = record
      if(soft.length === 5 && hard.length === 5) {
        // console.log(`>> CDU: bar ${index} both records complete`)
        completeTally++;
      }
      if(completeTally === 43) {
        console.log('>> Bar Regulation : ALL RECORDS COMPLETE!!!')
        // stop recording
        this.props.onSetLearnModeRecord(false);
        // reset strike type
        this.props.onSetStrikeType("soft");
        // select no bar
        this.props.onSelectLearnBar(-1);
        // set learn mode complete
        this.props.onLearnModeComplete(true);
      }
    })
  }

  render() {
    const {
      onSetLearnModeRecord,
      onSetStrikeType,
      onCreateBlankRecord,
      onResetBarRecord,
      onResetStrikeCount,
      currentLearnBar,
      learnModeRecording,
      learnModeStrikeType,
      learnModeStrikeCount,
      completedStrikes,
      learnModeComplete,
      showTooltips,
    } = this.props;

    const isSelected = currentLearnBar !== -1,
      striketype = learnModeStrikeType === "soft" ? 0 : 1;

    return (
      <div
        className={classnames("learn-mode-procedure", {
          recording: learnModeRecording,
        })}
      >
        <h3>
          Bar Regulation {learnModeComplete ? "Completed Successfully!" : ""}
        </h3>
        <div className="learn-steps">
          <div className={classnames("step-1", { na: !isSelected })}>
            <h4>1. Select a Bar</h4>
            <p className="selected-bar">
              {isSelected ? currentLearnBar + 1 : "---"}
            </p>
          </div>
          <div className="step-2">
            <h4>2. Select Type</h4>
            <Button
              name="Soft Tap"
              index={0}
              toggle={striketype}
              disabled={!isSelected || learnModeRecording}
              data-tip={tooltips["learn-mode-button-soft-strike"]}
              data-multiline="true"
              data-place="bottom"
              data-tip-disable={!showTooltips}
              onClick={() => {
                onSetStrikeType("soft");
              }}
            />
            <Button
              name="Hard Strike"
              index={1}
              toggle={striketype}
              disabled={!isSelected || learnModeRecording}
              data-tip={tooltips["learn-mode-button-hard-strike"]}
              data-multiline="true"
              data-place="top"
              data-tip-disable={!showTooltips}
              onClick={() => {
                onSetStrikeType("hard");
              }}
            />
          </div>
          <div className="step-3">
            <h4>3. Record Strikes</h4>
            <p className="step-count">
              {learnModeStrikeCount}/5
            </p>
            <Button
              name={learnModeRecording ? "Stop" : "Record"}
              data-multiline="true"
              data-tip={tooltips["learn-mode-button-record"]}
              data-place="top"
              data-type="info"
              data-tip-disable={learnModeRecording}
              index={1}
              toggle={learnModeRecording ? 1 : 0}
              disabled={!isSelected}
              onClick={() => {
                // TODO: check to see if a delay is needed here
                if (!learnModeRecording) {
                  // Record
                  onCreateBlankRecord();
                  onSetLearnModeRecord(true);
                } else {
                  // Cancel
                  onSetLearnModeRecord(false);
                }
                // reset bar record array on record / cancel
                onResetBarRecord();
                // reset strike count on record / cancel
                onResetStrikeCount();
              }}
            />
          </div>
          <div className="step-4">
            <h4>4. Results</h4>
            <p className="calculated-gain">
              Completed
              <br />
              Bar:
              <br />
              <span
                className={classnames({
                  complete: completedStrikes[currentLearnBar] === 3,
                })}
              >
                {completedStrikes[currentLearnBar] === 3 ? "√" : "N/A"}
              </span>
            </p>
          </div>
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    isRecording: state.editor.learnModeRecording,
    currentLearnBar: state.editor.selectedLearnBar,
    learnRecords: state.learnMode.records,
    completedStrikes: state.learnMode.completedStrikes,
    learnModeRecording: state.editor.learnModeRecording,
    learnModeStrikeType: state.editor.learnModeStrikeType,
    learnModeStrikeCount: state.editor.learnModeStrikeCount,
    learnModeComplete: state.editor.learnModeComplete,
    showTooltips: state.editorPreferences.showTooltips,
  };
}
const mapDispatchToProps = (dispatch) => {
  return {
    onSetLearnModeRecord: (recording) => {
      dispatch(setLearnModeRecord(recording));
    },
    onSelectLearnBar: (bar) => {
      dispatch(selectLearnBar(bar));
    },
    onSetStrikeType: (strikeType) => {
      dispatch(setLearnModeStrikeType(strikeType));
    },
    onCreateBlankRecord: () => {
      dispatch(createBlankRecord());
    },
    onResetBarRecord: () => {
      dispatch(resetBarRecord());
    },
    onCheckBarRecords: (record) => {
      dispatch(checkBarRecords(record));
    },
    onResetStrikeCount: () => {
      dispatch(setLearnStrikeCount(true));
    },
    onCalculateAndSendBarAvgs: () => {
      dispatch(calculateAndSendBarAverages());
    },
    onSetAndSendBarMults: () => {
      dispatch(storeAndSendBarMults());
    },
    onLearnModeComplete: (complete) => {
      dispatch(learnModeComplete(complete));
    },
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(LearnModeSteps)
